import { render, staticRenderFns } from "./listaDocumentos.vue?vue&type=template&id=a1b26daa"
import script from "./listaDocumentos.vue?vue&type=script&lang=js"
export * from "./listaDocumentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports